(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-live-banners"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=(root=document)=>root.querySelectorAll('[data-live-banners]').forEach(el=>{
 if(el.dataset.ready)return;el.dataset.ready='true';
 const slides=[...el.querySelectorAll('[data-slide]')],buttons=[...el.querySelectorAll('[data-slide-index]')],play=el.querySelector('[data-slideshow-play]'),controls=el.querySelector('[data-slide-controls]');
 if(!slides.length)return;
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
 let current=0,timer=null,paused=reduce.matches,hover=false,focused=false;
 const show=i=>{current=i;slides.forEach((s,j)=>s.hidden=i!==j);buttons.forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)))};
 const sync=()=>{clearInterval(timer);timer=null;play.textContent=paused?'Play slideshow ▷':'Pause slideshow Ⅱ';play.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');play.setAttribute('aria-pressed',String(paused));if(!paused&&!hover&&!focused&&!document.hidden&&slides.length>1)timer=setInterval(()=>show((current+1)%slides.length),4500)};
 buttons.forEach((b,i)=>b.addEventListener('click',()=>{show(i);sync()}));
 play.addEventListener('click',()=>{paused=!paused;sync()});
 el.addEventListener('mouseenter',()=>{hover=true;sync()});el.addEventListener('mouseleave',()=>{hover=false;sync()});
 el.addEventListener('focusin',()=>{focused=true;sync()});el.addEventListener('focusout',()=>setTimeout(()=>{focused=el.contains(document.activeElement);sync()},0));
 const visibility=()=>sync();document.addEventListener('visibilitychange',visibility);
 const motion=()=>{paused=reduce.matches;sync()};reduce.addEventListener('change',motion);
 el.addEventListener('shopify:block:select',e=>{const i=slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0){paused=true;show(i);sync()}});
 const unload=e=>{if(e.target.contains(el)){clearInterval(timer);document.removeEventListener('visibilitychange',visibility);reduce.removeEventListener('change',motion);document.removeEventListener('shopify:section:unload',unload)}};document.addEventListener('shopify:section:unload',unload);
 controls.hidden=false;show(0);sync();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
